const DEFAULT_DEBUG_ENABLED = false;

const resolveRuntimeToggle = () => {
    if (typeof window !== 'undefined' && typeof window.__NL_DEBUG_LOGS__ === 'boolean') {
        return window.__NL_DEBUG_LOGS__;
    }
    return DEFAULT_DEBUG_ENABLED;
};

const shouldLog = () => resolveRuntimeToggle() === true;

export const debugLogger = {
    log: (...args) => {
        if (shouldLog()) {
            console.log(...args);
        }
    },
    info: (...args) => {
        if (shouldLog()) {
            console.info(...args);
        }
    },
    warn: (...args) => {
        if (shouldLog()) {
            console.warn(...args);
        }
    }
};

export const setDebugLoggingEnabled = (enabled) => {
    if (typeof window !== 'undefined') {
        window.__NL_DEBUG_LOGS__ = !!enabled;
    }
};
